import _get from 'lodash/get';
import landing from '../data/V2/landing_page-config/meta.json';

const v1tov2Utils = {
  imageProcess: (images, type) => [
    {
      file_url: images[0],
      path: `./assets/images/banner_${type}_1.jpg`,
    },
    {
      file_url: images[1],
      path: `./assets/images/banner_${type}_2.jpg`,
    },
    {
      file_url: images[2],
      path: `./assets/images/banner_${type}_3.jpg`,
    },
  ],
  mapNewKey: obj => {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
      const r = {};
      for (const [k, v] of Object.entries(value)) {
        if (k === 'notGood') {
          r['fair'] = v;
        } else {
          r[k] = v;
        }
      }
      result[key] = r;
    }
    return result;
  },
  mapNewCategory: obj => {
    const result = {};
    for (const [l, lv] of Object.entries(obj)) {
      const rl = {};
      for (const [c, cv] of Object.entries(lv)) {
        const rc = {};
        for (const [s, sv] of Object.entries(cv)) {
          if (s === 'notGood') {
            rc['fair'] = sv;
          } else {
            rc[s] = sv;
          }
        }
        if (c === 'dark_circle_v2') {
          rl['darkCircle'] = rc;
        } else if (c === 'age_spot') {
          rl['spot'] = rc;
        } else if (c !== 'dark_circle') {
          rl[c] = rc;
        }
      }
      result[l] = rl;
    }
    return result;
  },
  mapTabsValue: value => {
    const mapData = [
      'routineRecommend',
      'productRecommend',
      'treatmentRecommend',
    ];
    const data = value.map(r => r.value);
    return mapData.map(r => ({
      enable: data.includes(r),
      value: r,
    }));
  },
  parserLandingDataConfig: data => {
    return {
      page: [
        {
          templateType: 'skincare',
          pageType: 'landing',
          mainImage: [
            {
              deviceType: 'pad',
              images: ['./assets/images/banner_pad_1.jpg', '', ''],
              imagesUrl: [
                'https://app-cdn-01.perfectcorp.com/console-demo/customer/226/19226/TemplateImage/566/464722c7-da99-4dba-9492-77d6ee26ee92.png',
                '',
                '',
              ],
              autoplayTimeout:
                _get(data, 'body.banners[0].autoplayTimeout') * 1000,
            },
            {
              deviceType: 'phone',
              images: ['./assets/images/banner_phone_1.jpg', '', ''],
              imagesUrl: [
                'https://app-cdn-01.perfectcorp.com/console-demo/customer/226/19226/TemplateImage/303/5285cf2a-ae72-422a-a29d-3e1b06e22aa0.png',
                '',
                '',
              ],
              autoplayTimeout:
                _get(data, 'body.banners[1].autoplayTimeout') * 1000,
            },
            {
              deviceType: 'padLandscape',
              images: ['./assets/images/banner_pad_landscape_1.jpg', '', ''],
              imagesUrl: [
                'https://app-cdn-01.perfectcorp.com/console-demo/common/misc/template_default_config/image/banner_pad_landscape_1.jpg',
                '',
                '',
              ],
              autoplayTimeout: 60000,
            },
          ],
        },
      ],
    };
  },
  parserLandingDataMeta: () => {
    return landing;
  },
  parserResultDataConfig: data => {
    const values = _get(data, 'langs[0].page');
    return {
      page: [
        {
          templateType: 'skincare',
          pageType: 'getSkincareResult',
          general: {
            enableRecommendation: _get(values, 'header.topTabs.enable'),
            showFooterButton: _get(values, 'buttons[0].enable'),
          },
          skinReport: {
            resultPage: {
              showTimeStamp: _get(values, 'skincareHtmlResult.enableTimestamp'),
              showSkinAge: _get(values, 'skincareHtmlResult.skinAge.enable'),
              showSkinScore: _get(
                values,
                'skincareHtmlResult.skinHealth.enable'
              ),
              showSkinScoreComment: _get(
                values,
                'skincareHtmlResult.skinHealth.comment.enable'
              ),
              scoreBar: {
                avgLowerBound: _get(
                  values,
                  'skincareHtmlResult.skinHealth.score.avgLowerBound'
                ),
                avgUpperBound: _get(
                  values,
                  'skincareHtmlResult.skinHealth.score.avgUpperBound'
                ),
                barColors: {
                  fair: _get(
                    values,
                    'skincareHtmlResult.skinHealth.score.barColors.notGood'
                  ),
                  average: _get(
                    values,
                    'skincareHtmlResult.skinHealth.score.barColors.average'
                  ),
                  good: _get(
                    values,
                    'skincareHtmlResult.skinHealth.score.barColors.good'
                  ),
                },
              },
            },
            summary: {
              show: _get(
                values,
                'skincareHtmlResult.skinHealth.summary.enable'
              ),
              description: v1tov2Utils.mapNewKey(
                _get(
                  values,
                  'skincareHtmlResult.skinHealth.summary.contentI18n',
                  {}
                )
              ),
            },
            card: {
              showComment: _get(
                values,
                'skincareHtmlResult.detection.comment.enable'
              ),
              showDescription: _get(
                values,
                'skincareHtmlResult.detection.description.enable'
              ),
              description: v1tov2Utils.mapNewCategory(
                _get(values, 'skincareHtmlResult.detection.description.i18n')
              ),
              category: 'spot',
            },
          },
          recommendation: {
            showSummary: _get(
              values,
              'skincareHtmlResult.recommendSummary.enable'
            ),
            showProductCardBusinessName: _get(
              values,
              'skincareHtmlResult.productRecommend.enabledInfo',
              []
            ).includes('brandName'),
            backgroundImage: [
              {
                type: 'phone',
                image:
                  './assets/images/img_skincarepro_resultpg_topbg_phone.jpg',
                imageUrl: _get(
                  values,
                  'skincareHtmlResult.recommendSummary.backgroundImage[0].image',
                  ''
                ),
              },
              {
                type: 'pad',
                image: './assets/images/img_skincarepro_resultpg_topbg_pad.jpg',
                imageUrl: _get(
                  values,
                  'skincareHtmlResult.recommendSummary.backgroundImage[1].image',
                  ''
                ),
              },
              {
                type: 'padLandscape',
                image:
                  './assets/images/img_skincarepro_resultpg_topbg_landscape.jpg',
                imageUrl: _get(
                  values,
                  'skincareHtmlResult.recommendSummary.backgroundImage[2].image',
                  ''
                ),
              },
            ],
            tabs: v1tov2Utils.mapTabsValue(
              _get(
                values,
                'skincareHtmlResult.recommendSummary.layoutItems',
                []
              )
            ),
            text: {
              summary: _get(
                values,
                'skincareHtmlResult.recommendSummary.contentI18n'
              ),
              productHeading: _get(
                values,
                'skincareHtmlResult.productRecommend.heading.textI18n'
              ),
              routineHeading: _get(
                values,
                'skincareHtmlResult.routineRecommend.heading.textI18n'
              ),
              treatmentHeading: _get(
                values,
                'skincareHtmlResult.treatmentRecommend.heading.textI18n'
              ),
              textLanguage: {
                label: 'English',
                value: 'enu',
              },
            },
          },
        },
        {
          templateType: 'skincare',
          pageType: 'analysisGetPhoto',
          accessOptions: {
            showQRCode: _get(values, 'featureConfig.getPhoto.qrCode.enabled', false),
            showEmail: _get(values, 'featureConfig.getPhoto.email.enabled', false),
            showPrint: true,
          },
        },
      ],
    };
  },
  parserResultDataMeta: data => {
    const values = _get(data, 'langs[0].page');
    return {
      files: [
        {
          file_url: _get(
            values,
            'skincareHtmlResult.recommendSummary.backgroundImage[0].image',
            ''
          ),
          path: './assets/images/img_skincarepro_resultpg_topbg_phone.jpg',
        },
        {
          file_url: _get(
            values,
            'skincareHtmlResult.recommendSummary.backgroundImage[1].image',
            ''
          ),
          path: './assets/images/img_skincarepro_resultpg_topbg_pad.jpg',
        },
        {
          file_url: _get(
            values,
            'skincareHtmlResult.recommendSummary.backgroundImage[2].image',
            ''
          ),
          path: './assets/images/img_skincarepro_resultpg_topbg_landscape.jpg',
        },
      ],
    };
  },
  parserCommonDataConfig: data => ({
    page: [
      {
        templateType: 'skincare',
        pageType: 'common',
        createForm: {
          firstName: 'required',
          lastName: 'required',
          dateOfBirth: 'required',
          email: 'optional',
          phone: 'optional',
          gender: 'optional',
        },
        header: {
          logo: {
            image: './assets/images/pf_logo.png',
            imageUrl: _get(data, 'header.logo.image'),
          },
        },
      },
    ],
  }),
  parserCommonDataMeta: data => ({
    files: [
      {
        file_url: _get(data, 'header.logo.image'),
        path: './assets/images/pf_logo.png',
      },
    ],
  }),
};

export default v1tov2Utils;
